module.exports = __webpack_public_path__ + "img/order_image_two@2x.f751f241.png";